import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
import { Tag } from 'antd'
export const TopSectionFlex = styled(Flex)`
  margin-bottom: 100px;
`
export const RoleDescription = styled.div`
  min-width: 100%;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  color: ${COLORS.GREY_T_20};
`
export const SalaryDetailsFlex = styled(Flex)`
  gap: 10px;
`
export const PaymentsSpan = styled.span`
  padding: 5px 10px 0 0;
`
export const SalarySpan = styled.span`
  font-family: 'Plus Jakarta Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: ${COLORS.GREY_T_60};
  padding-top: 4px;
`
export const RolesInfoFlex = styled(Flex)`
  align-items: center;
`
export const RoleDescriptionDiv = styled.div`
  min-width: 100%;
`
export const FullTimeSpan = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: ${COLORS.GREY_T_30};
  padding: 0 0 0 5px;
  text-transform: lowercase;
  &::first-letter {
    text-transform: capitalize;
  }
`
export const PeopleCountSpan = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: ${COLORS.GREY_T_30};
  padding: 0 10px;
`
export const SalaryDiv = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: ${COLORS.GREY_T_30};
  padding-bottom: 15px;
  border-bottom: 1px solid ${COLORS.GREY_T_90};
`
export const RolesInformationDiv = styled.div`
  width: 60%;
`
export const SalaryInfoDiv = styled.div`
  width: 30%;
`
export const GroupPepoleDiv = styled(Flex)`
  padding: 0 15px;
  border-right: 1px solid ${COLORS.GREY_T_80};
`
export const GroupFlex = styled(Flex)`
  padding: 0 15px 0 0;
  border-right: 1px solid ${COLORS.GREY_T_80};
`
export const FreeCancelFlex = styled(Flex)`
  padding: 0 15px;
`

export const ApplySpan = styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: ${COLORS.GREY_T_60};
  padding: 0 5px;
`
export const DurationSpan = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: ${COLORS.GREY_T_30};
`
export const FullTimeDiv = styled.div`
  margin: 10px 0;
`
export const JobDescriptionDiv = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: ${COLORS.GREY_T_30};
`
export const LocationSpan = styled.div`
  padding: 0 10px 0 0;
`
export const JobLocationDiv = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: ${COLORS.GREY_T_30};
`
export const LocationFlex = styled(Flex)`
  margin: 10px 0;
`
export const DescriptionP = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: ${COLORS.PRIMARY_GREY_T_50};
  margin: 10px 0;
  strong {
    color: ${COLORS.GREY_T_50};
  }
`
export const DescriptionPointsUl = styled.ul`
  padding-inline-start: 30px;
`
export const DescriptionList = styled.li`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #808697;
`
export const KeyRespoDiv = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: ${COLORS.GREY_T_30};
`
export const InterviewRoundsDiv = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  color: ${COLORS.GREY_T_30};
`
export const LocationList = styled.li`
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  color: #808697;
`
export const RemoteFriendlyDiv = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: ${COLORS.GREY_T_30};
`
export const RemoteLocationDiv = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: ${COLORS.GREY_T_60};
  padding: 5px 0 15px 0;
  border-bottom: 1px solid ${COLORS.GREY_T_80};
`
export const RemoteSpan = styled.span`
  color: ${COLORS.GREY_T_30} !important;
  margin-right: ${props => (props.marginRight ? props.marginRight : '0px')};
`
export const CriteriaDiv = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: ${COLORS.GREY_T_20};
  padding: 0 0 0 10px;
`
export const CriteriaFlex = styled(Flex)`
  margin: 15px 0;
`
export const DepartmentDiv = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: ${COLORS.GREY_T_20};
  padding-top:15px;
`
export const BranchDiv = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  color: ${COLORS.GREY_T_20};
  margin-bottom: 15px;
`
export const BranchSpan = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  color: ${COLORS.GREY_T_20};
  margin: 0 10px 15px 0;
  text-transform: lowercase;
  display: block;
  &::first-letter {
    text-transform: uppercase;
  }
`
export const YearOfPassDiv = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: ${COLORS.GREY_T_60};
  margin-top: 15px;
`
export const SubHeading = styled(YearOfPassDiv)``
export const EducationDetailsDiv = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  color: ${COLORS.GREY_T_20};
  margin-bottom: 5px;
  line-height: 24px;
`
export const AvarageMarksDiv = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: ${COLORS.GREY_T_20};
  line-height: 20px;
`
export const SkillsTags = styled(Tag)`
  background: ${COLORS.BLUE_T_95};
  border-radius: 6px;
  color: ${COLORS.GREY_P_100};
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  padding: 4px;
  margin: 5px 3px;
  border: none;
`
export const ConnectSpan = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: ${COLORS.GREY_T_30};
`
export const CompanyUrlDiv = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: ${COLORS.GREY_T_30};
  margin-bottom: 10px;
  word-break: break-all;
`
export const SocialMeadiaIconsFlex = styled(Flex)`
  gap: 10px;
  border-bottom: 1px solid ${COLORS.GREY_T_90};
  padding-bottom: 18px;
`
export const LocationConnectFlex = styled(Flex)`
  gap: 10px;
  margin-top: -10px;
`
export const LocationUl = styled.ul`
  padding-inline-start: 23px;
  padding-bottom: 15px;
  border-bottom: 1px solid ${COLORS.GREY_T_90};
`
export const RoundsDiv = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: ${COLORS.GREY_T_30};
  margin: 10px 0;
`
export const TestsDiv = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: ${COLORS.GREY_T_30};
  margin: 10px 0;
`
export const TestInfoLi = styled.li`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #808697;
`
export const JobLocationUl = styled.ul`
  padding-inline-start: 23px;
`
export const VideoDiv = styled.video`
  width: 682px;
  height: 412px;
  background: #f5f6fd;
  border-radius: 10px;
`
export const YearSpan = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  color: ${COLORS.GREY_T_20};
  margin: 0 5px 15px 0;
`
export const RoleNameFlex = styled(Flex)``
export const TopEndFlex = styled(Flex)`
  gap: ${props => (props?.gap ? props?.gap : '0')};
`
export const RoleNameDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XL};
  color: ${COLORS.GREY_T_20};
  margin-right: 10px;
  text-transform: capitalize;
`
export const InfoText = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.SM};
  line-height: 30px;
  color: ${COLORS.GREY_T_50_2};
  margin-bottom: ${props => (props.marginbottom ? props.marginbottom : '0px')};
  margin-left: ${props => (props.marginleft ? props.marginleft : '0px')};
  margin-right: ${props => (props.marginRight ? props.marginRight : '0px')};
  text-transform: ${props => (props.capitalize ? 'capitalize' : 'none')};
  padding-top: ${props => (props.paddingTop ? props.paddingTop : '0px')};
`
export const FlexWrap = styled(Flex)`
  position: relative;
  gap: ${props => (props.gap ? props.gap : '0px')};
  padding: ${props => (props.padding ? props.padding : '0px')};
  background-color: ${props => (props.bgColor ? props.bgColor : 'transparent')};
`
export const GrayTextSmall = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 30px;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_20)};
  margin-bottom: ${props => (props.marginbottom ? props.marginbottom : '0px')};
  text-transform: ${props => (props.capitalize ? 'capitalize' : 'none')};
`
export const SubtitleSmall = styled.p`
  font-style: normal;
  font-weight: ${props => (props.fontweight ? props.fontweight : FONT.FW_400)};
  font-size: ${props => (props.fontsize ? props.fontsize : FONT.F_SM)};
  line-height: 20px;
  color: ${props => (props.color ? props.color : COLORS.GREY_T_30)};
  margin-bottom: ${props => (props.marginbottom ? props.marginbottom : '5px')};
  padding: ${props => (props.padding ? props.padding : '')};
  text-transform: ${props => (props.capitalize ? 'capitalize' : 'none')};
  span {
    font-style: normal;
    font-weight: ${FONT.FW_600};
    line-height: 18px;
    color: ${COLORS.GREY_T_10};
    margin-right: 5px;
  }
  ${props => props.afterContent && `::after { content: ',';}`}

  :last-child:after {
    content: '';
  }
`

export const SkillList = styled.ul`
  padding-inline-start: 20px;
`
